













































































































import HeaderComponent from './landing-sections/Header.vue';
import FooterComponent from '../docs-main/Footer.vue';
import { Component } from 'vue-property-decorator';
import Vue from 'vue';
import SearchInput from '@/components/docs-main/search/SearchInput.vue';
import { StoreActions, StoreMutations } from '@/templates/DataNames';
import { Action, Mutation } from 'vuex-class';
import { parseHrefHelper } from '@/heplers/stringHelpers';
import { TutorialFilterType } from '@/templates/Tutorial';
import { valueof } from '@/templates/Tree';
import { GtmEvent, GtmMarked } from '@/plugins/gdprPlugin';
import DocButton from '@/components/ui/buttons/DocButton.vue';

enum TutorialsFilter {
  'VOICE' = 'Voice',
  'VIDEO' = 'Video',
  'MESSAGING' = 'Messaging',
  'AVATAR' = 'Avatar',
}

interface ITutorialLinkObject {
  link?: string;
  name?: string;
  imageUrl?: string;
  isDocLink?: boolean;
}

interface ITutorialsList extends GtmMarked {
  list: ITutorialLinkObject[];
}

@Component({
  components: {
    DocButton,
    SearchInput,
    HeaderComponent,
    FooterComponent,
  },
  metaInfo() {
    return {
      title:
        typeof window === 'undefined' ? 'Voximplant Documentation' : 'Voximplant Documentation',
      script: [
        {
          type: 'application/ld+json',
          json: {
            '@context': 'https://schema.org',
            '@type': 'WebSite',
            url: 'https://voximplant.com/docs/',
            potentialAction: {
              '@type': 'SearchAction',
              target: 'https://voximplant.com/docs/search?q={search_term_string}',
              'query-input': 'required name=search_term_string',
            },
          },
        },
      ],
    };
  },
})
export default class Landing extends Vue {
  @Action(StoreActions.CONTENT) actionContent: any;
  @Mutation(StoreMutations.UPDATE_LANGUAGES_PACK) mutateLang: (lang: string) => void;
  @Mutation(StoreMutations.SET_LANGUAGES) mutateAllLanguages: (languages: any) => void;
  @Mutation(StoreMutations.CONTENT) setContent: (content: any) => void;
  tutorialsFilterEnum: { [key in keyof TutorialFilterType]: valueof<TutorialsFilter> } = {
    isAudio: 'Voice',
    isVideo: 'Video',
    isMessaging: 'Messaging',
    isAvatar: 'Avatar',
  };

  filteredTutorials: Record<TutorialsFilter, ITutorialsList> = {
    Voice: {
      gtm: {
        event: 'vox_docs_to_voice_docs',
        category: 'docs_links',
        action: 'voice_docs',
      },
      list: [
        {
          name: 'Voice calls',
          link: 'guides.calls.audio',
        },
        {
          name: 'Speech synthesis',
          link: 'guides.speech.tts',
        },
        {
          name: 'Speech recognition',
          link: 'guides.speech.stt',
        },
      ],
    },
    Video: {
      gtm: {
        event: 'vox_docs_to_video_docs',
        category: 'docs_links',
        action: 'video_docs',
      },
      list: [
        {
          name: 'Video calls',
          link: 'guides.calls.video',
        },
        {
          name: 'Video conferences',
          link: 'guides.conferences.howto',
        },
        {
          name: 'Video recording',
          link: 'guides.calls.record',
        },
      ],
    },
    Messaging: {
      gtm: {
        event: 'vox_docs_to_messaging_docs',
        category: 'docs_links',
        action: 'messaging_docs',
      },
      list: [
        {
          name: 'Instant messaging',
          link: 'guides.im',
        },
        {
          name: 'SMS',
          link: 'guides.sms',
        },
      ],
    },
    Avatar: {
      gtm: {
        event: 'vox_docs_to_avatar_docs',
        category: 'docs_links',
        action: 'avatar_docs',
      },
      list: [
        {
          name: 'Avatar voice and chat bot engine',
          link: 'guides.ai.avatar',
        },
        {
          name: 'Voicemail detection',
          link: 'guides.ai.voicemail',
        },
      ],
    },
  };

  mediaSdks: ITutorialsList = {
    gtm: {
      event: 'vox_docs_to_media_sdk_docs',
      category: 'docs_links',
      action: 'media_sdk_docs',
    },
    list: [
      {
        name: 'IOS',
        link: 'references.iossdk',
        imageUrl: 'ios',
      },
      {
        name: 'Android',
        link: 'references.androidsdk',
        imageUrl: 'android',
      },
      {
        name: 'React Native',
        link: 'references.reactnative',
        imageUrl: 'react-native',
      },

      {
        name: 'Web',
        link: 'references.websdk',
        imageUrl: 'websdk',
      },
      {
        name: 'Flutter',
        link: 'references.fluttersdk',
        imageUrl: 'flutter',
      },
    ],
  };

  apiClients: ITutorialsList = {
    gtm: {
      event: 'vox_docs_to_api_clients_docs',
      category: 'docs_links',
      action: 'api_clients_docs',
    },
    list: [
      {
        name: 'Curl',
        imageUrl: 'curl',
        isDocLink: true,
        link: 'references.httpapi',
      },
      {
        name: 'Node.js',
        imageUrl: 'node',
        link: 'https://www.npmjs.com/package/@voximplant/apiclient-nodejs',
      },
      {
        name: 'Python',
        imageUrl: 'python',
        link: 'https://pypi.org/project/voximplant-apiclient/',
      },
      {
        name: 'PHP',
        imageUrl: 'php',
        link: 'https://packagist.org/packages/voximplant/apiclient-php',
      },
      {
        name: 'Go',
        imageUrl: 'go',
        link: 'https://github.com/voximplant/apiclient-go',
      },
      {
        name: 'Java',
        imageUrl: 'java',
        link: 'https://github.com/voximplant/apiclient-java',
      },
      {
        name: 'C#',
        imageUrl: 'csharp',
        link: 'https://github.com/voximplant/apiclient-dotnet',
      },
    ],
  };

  sdkTools: ITutorialsList = {
    gtm: {
      event: 'vox_docs_to_tools_docs',
      category: 'docs_links',
      action: 'tools_docs',
    },
    list: [
      {
        name: 'Cloud IDE',
        imageUrl: 'ide',
        link: 'guides.voxengine.ide',
      },
      {
        name: 'Debugger',
        imageUrl: 'debugger',
        link: 'guides.troubleshooting.scenarios',
      },
    ],
  };

  parseHref = parseHrefHelper;

  mounted() {
    this.sendGtmEvent(
      {
        event: 'vox_docs_open',
        category: 'main_docs',
        action: 'open',
      },
      document.referrer
    );
    this.setContent([]);
  }

  goToTutorialsFilter(filterName: valueof<TutorialsFilter>, link: string) {
    Object.keys(this.tutorialsFilterEnum).filter((value) => {
      if (this.tutorialsFilterEnum[value as keyof TutorialFilterType] === filterName) {
        if (!link) this.$router.push('/docs/tutorials').catch((error) => error);
        else {
          this.goToLink(link);
        }
      }
    });
  }

  setLanguage(lang: string) {
    this.mutateLang(lang);
  }

  getStartedClickHandler() {
    this.sendGtmEvent({
      event: 'vox_docs_to_getting_started',
      category: 'main_docs',
      action: 'get_started',
    });
    this.goToLink('getting-started', true);
  }

  serverlessClickHandler() {
    this.sendGtmEvent({
      event: 'vox_docs_to_ve_docs',
      category: 'docs_links',
      action: 've_docs',
    });
    this.goToLink('references.voxengine');
  }

  toolClickHandler(gtm: GtmEvent, tool: ITutorialLinkObject) {
    this.sendGtmEvent(gtm, tool.name.toLowerCase());
    this.goToLink(tool.link);
  }

  sendGtmEvent(event: GtmEvent, label?: string) {
    this.$sendGtmEvent({
      ...event,
      label,
    });
  }

  goToLink(fqdn: string, getStarted?: boolean) {
    if (getStarted) {
      this.sendGtmEvent({
        event: 'site_main_docs_get_started',
        category: 'main_docs',
        action: 'get_started',
      });
    }

    try {
      this.$localStorageSet('fromLanding', 'true');
    } catch (error) {
      console.error('Failed to set item to localStorage', error);
    }

    this.actionContent({ fqdn: fqdn })
      .then(() => this.$router.push(this.parseHref(fqdn)).catch((error: any) => error))
      .catch((error: any) => error);
  }

  goToHttpapiAndSetLang(apiTitle: string) {
    let prepareLang = apiTitle.replace(/\./, '').toLowerCase();
    this.setLanguage(prepareLang);
    this.goToLink('references.httpapi');
  }
}
